import { useLoader, useThree } from "@react-three/fiber";
import Panorama from "./Panorama";
import HotSpot from "./Hotspot";
import InfoTextSpot from "./InfoTextSpot";
import VideoPlane from "./VideoPlane";
import { TextureLoader } from "three/src/loaders/TextureLoader";
import { LinearFilter } from "three/src/constants";
import InfoImageSpot from "./InfoImageSpot";
import { useEffect, useContext } from "react";
import ExperienceContext from "./ExperienceContext";
import PanoSpot from "./PanoSpot";
import VideoSpot from "./VideoSpot";
import ThreeDSpot from "./ThreeDSpot";
import EmbedLinkSpot from "./EmbedLinkSpot";
import AudioSpot from "./AudioSpot";
import { CDN_URL } from "../../constant";
function Experience({
	panoramaDetails,
	selectObject,
	transformControl,
	setActivePanoId,
	isPreviewComponent,
	setInfoImageSpotDetails,
	setIsInfoImageSpotOpen,
	setIsInfoTextSpotOpen,
	setIsInfoVideoSpotOpen,
	setInfoVideoSpotDetails,
	setIsInfoThreeDSpotOpen,
	setInfoThreeDSpotDetails,
	setAudioSpotDetails,
	setIsAudioSpotOpen,
	setPanoSpotDetails,
	setIsPanoSpotOpen,
}) {
	const { setCamera, setScene, setViewport } = useContext(ExperienceContext);
	const { camera, scene, viewport } = useThree(); // Don't remove this line
	camera.layers.enableAll();
	useEffect(() => {
		setCamera(camera);
		setScene(scene);
		setViewport(viewport);
	}, [camera, scene, viewport]);

	const texture = useLoader(TextureLoader, CDN_URL + panoramaDetails.url);
	texture.minFilter = texture.magFilter = LinearFilter;
	if (!panoramaDetails) return;
	const Spots = panoramaDetails.spots.map((spot) => {
		if (spot.type === "hotspot") {
			return (
				<HotSpot
					key={spot.id}
					hotspot={spot}
					selectObject={selectObject}
					isPreviewComponent={isPreviewComponent}
					setActivePanoId={setActivePanoId}
				/>
			);
		}
		if (spot.type === "text") {
			return (
				<InfoTextSpot
					key={spot.id}
					infoSpot={spot}
					selectObject={selectObject}
					isPreviewComponent={isPreviewComponent}
					setIsInfoTextSpotOpen={setIsInfoTextSpotOpen}
				/>
			);
		}
		if (spot.type === "link") {
			return (
				<EmbedLinkSpot
					key={spot.id}
					embedLinkSpot={spot}
					selectObject={selectObject}
					isPreviewComponent={isPreviewComponent}
				/>
			);
		}
		if (spot.type === "image") {
			return (
				<InfoImageSpot
					key={spot.id}
					imageSpot={spot}
					selectObject={selectObject}
					isPreviewComponent={isPreviewComponent}
					setIsInfoImageSpotOpen={setIsInfoImageSpotOpen}
					setInfoImageSpotDetails={setInfoImageSpotDetails}
				/>
			);
		}
		if (spot.type === "video") {
			return (
				<VideoSpot
					key={spot.id}
					videoSpot={spot}
					selectObject={selectObject}
					isPreviewComponent={isPreviewComponent}
					setIsInfoVideoSpotOpen={setIsInfoVideoSpotOpen}
					setInfoVideoSpotDetails={setInfoVideoSpotDetails}
				/>
			);
		}
		if (!isPreviewComponent && spot.type === "inline-video") {
			return <VideoPlane key={spot.id} inlineVideoSpot={spot} />;
		} else if (spot.type === "inline-video") {
			return (
				<VideoPlane
					key={spot.id}
					inlineVideoSpot={spot}
					selectObject={selectObject}
				/>
			);
		}
		if (spot.type === "pano") {
			return (
				<PanoSpot
					key={spot.id}
					panoSpot={spot}
					selectObject={selectObject}
					isPreviewComponent={isPreviewComponent}
					setIsPanoSpotOpen={setIsPanoSpotOpen}
					setPanoSpotDetails={setPanoSpotDetails}
				/>
			);
		}
		if (spot.type === "three-d") {
			return (
				<ThreeDSpot
					key={spot.id}
					threeDSpot={spot}
					selectObject={selectObject}
					isPreviewComponent={isPreviewComponent}
					setIsInfoThreeDSpotOpen={setIsInfoThreeDSpotOpen}
					setInfoThreeDSpotDetails={setInfoThreeDSpotDetails}
				/>
			);
		}
		if (spot.type === "audio") {
			return (
				<AudioSpot
					key={spot.id}
					audioSpot={spot}
					selectObject={selectObject}
					isPreviewComponent={isPreviewComponent}
					setIsAudioSpotOpen={setIsAudioSpotOpen}
					setAudioSpotDetails={setAudioSpotDetails}
				/>
			);
		}
		return null;
	});
	return (
		<>
			<Panorama texture={texture} />
			{Spots}
		</>
	);
}

export default Experience;
